












































import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import {
  axios,
} from '@/api';
import useSubJob from '@/use/useSubJob';

import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

const NOW = useFormat.date().computerShortDate();
const defaultCsvVariables = {
  csv_type: 'FAB',
  csv_module_no: '',
  csv_target_date: NOW,
  multiplier: 1,
};

const PanelWithSubJobUpload = defineComponent({
  components: {
    CommonDropzoneWithAxios,
  },
  props: {
    jobId: { required: true },
    enabled: { default: false },
  },
  setup(props, { emit }) {
    const { subJobType } = useSubJob();
    // ======= Upload Sub job =========
    const uploadCsvVariables = reactive(defaultCsvVariables);
    function uploadDone(e: any) {
      uploadCsvVariables.csv_type = 'FAB';
      uploadCsvVariables.csv_module_no = '';
      uploadCsvVariables.csv_target_date = NOW;
      uploadCsvVariables.multiplier = 1;
      emit('done', e.message.stock_data);
    }
    const allowedToUpload = computed(() => {
      if (uploadCsvVariables.csv_module_no === '') return false;
      return true;
    });
    // ====================================

    return {
      axios,
      subJobType,
      uploadCsvVariables,
      uploadDone,
      allowedToUpload,
    };
  },
});

export default PanelWithSubJobUpload;
